import React, {Fragment, useState, useRef} from  'react';
import {NavLink } from 'react-router-dom'
// import {ReactComponent as Logo} from 'assets/images/svg/logo.svg';
import {HelpIcon, ChevronDown, UserIcon,LogOutIcon, SettingsIcon, SearchIcon, LogoSmall, MenuIcon, CloseIcon } from 'components/vectors'
import { logout, getUserToken } from 'libs/helpers';
import ArtisteListItem from 'components/blocks/ArtisteListItem'


const CommonHeader2 = props => {
    const { match, history} = props
    const [showFilter, toggleShowFilter] = useState(false);
    const [artistes, setArtistes] = useState({});
    const [showAutocomplete, setShowAutocomplete] = useState(false); //
    const [stations, setStations] = useState([]);
    const [hasSelectedSubStation, setHasSelectedSubStation] = useState(false);
    const [filterParams, setFilterParams] = useState({})
    const [searchValue, setSearchValue] = useState('')
    const ref = useRef(null);
    const [isLoadingStation, setIsLoadingStation] = useState(false);
    const [filterInput, setFilterInput] = useState('');
    const [filteredSubstation, setFilteredSubstation] = useState([]);
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const logOut = () => {
        logout()
        history.push('login');
        // return <Redirect to={{ pathname: '/login'}} />
    }


    const handleChange = ( event ) => {
        const {value} = event.target;
        setSearchValue(value)
        setShowAutocomplete(true);
        setHasSelectedSubStation(false) // here the user has NOT selected a substation
        
        if (value.trim() === ''){
            toggleShowFilter(false)
            return;
        }

        toggleShowFilter(true)
        setFilterParams({...filterParams, artist:value}) // sets the aristename for the filter 
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/get_assigned_search?artist_name=${value}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            console.log(res)
            if(res.code === 200){
                setArtistes(res.data)
                // ref2.current.click();
            }
            
            // console.log(res);
        })
        .catch( err =>{  //console.log(err)
        });
    }

    const handleRadioChange = ( event ) => {
        const { value } =  event.target
        setFilterParams({...filterParams, station:value})  // sets station for the filter
        setStations([]) // reset the substation to empty 
        setIsLoadingStation(true) // set loading to true for substation
        setHasSelectedSubStation(false) // here the user has NOT selected a substation
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/subsource?source=${value}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            // console.log(res)
            setIsLoadingStation(false) // set loading to true for substation
            if(res.code === 200){
                setStations(res.data.stations)
                setFilteredSubstation(res.data.stations)
            }
            
        })
        .catch( err => {
            setIsLoadingStation(false) // set loading to true for substation
            // console.log(err)
        });

    }

    const handleSubstationChange = (event) => {
        const {value} = event.target
        // console.log('HEADER', value)
        setHasSelectedSubStation(true) // here the user has selected a substation
        setFilterParams({...filterParams, substation:value})
    }

    const handleArtisteSelect = (artistName) => {
        // console.log('ARTISTE', artistName)
        setSearchValue(artistName);
        setFilterParams({...filterParams, artist:artistName}) // sets the aristename for the filter 
        ref.current.click() // opens the filter panel after selecting an artiste
    }

    const handleFilter = () =>  {
        ref.current.click(); // this click closes the filter dropdown
        props.filter(filterParams) // this uses the method passed Here and adds params to it
    }

    const handleSubstationFilter = (event) => {
        const { value } = event.target;
        setFilterInput(value)
        
        setFilteredSubstation(stations.filter( station => station.label.toLowerCase().includes(value.toLowerCase())))

    }

    const toggleShowMobileMenu = (bool) => {
        setShowMobileMenu(bool);
    }

    return <Fragment>
        <div className="position-relative">
            <div className="row header alternate">
                <div className="col-md-3 col-6">
                    <NavLink to="/"><LogoSmall /></NavLink>
                </div>
                <div className="col-2 ml-auto menu-icon" onClick= {() => { toggleShowMobileMenu(true)}}>
                    <MenuIcon />
                </div>                
                <div className="col-sm-12 col-md-9">
                    <ul className="menu-list">
                        <li className="col-md-8 px-0 menu-list-item">
                            <div className="w-100 menu-search">
                                <SearchIcon />
                                <input className="nsForm-input" placeholder="Search for Artistes"
                                 value={searchValue} onChange={handleChange} 
                                 onBlur={ () => { setTimeout( () =>{setShowAutocomplete(false)}, 100)}}/>
                                <div className={`d-flex flex-row align-items-center filter ${showFilter ? null: 'disable'}`} onClick={ showFilter ? ()=> ref.current.click():  null }>
                                    <p className={`text--small ${showFilter ? 'text--secondary': 'text--white'}`}>Filter by</p>
                                    {/* <div className="mBage ml-2">12</div> */}
                                </div>
                            </div>
                        </li>
                        <li className="menu-list-item alternate ">
                            <HelpIcon /> Help
                        </li>
                        <li className="menu-list-item alternate dropdown">
                            <div  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                My Account <ChevronDown />
                            </div>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div className="dropdown-item">My Account <ChevronDown/></div>
                                <NavLink to={`${match.url}/profile`} className="dropdown-item"> <UserIcon width="16" height="16"/>Profile</NavLink>
                                <NavLink to={`${match.url}/profile/email`} className="dropdown-item"> <SettingsIcon/> Settings</NavLink>
                                <div className="dropdown-item" onClick={logOut}> <LogOutIcon />Log out</div>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
            <div className="filter-container">
                <div className="row">
                    <div className="col-md-9 offset-md-3">
                        <div className="col-md-8 px-0 filter-main">
                            {
                                showAutocomplete ? 
                                <ul>
                                {/* assigned_artist */}
                                {artistes.hasOwnProperty('assigned_artist') ? 
                                    <ArtisteListItem name={artistes.assigned_artist} handleClick={handleArtisteSelect} error={false}/>
                                    : <ArtisteListItem name={''} handleClick={handleArtisteSelect} error={true}/>
                                }
                                    

                                    {/* { artistes && artistes.map( (artist, index) => (
                                        <ArtisteListItem key={index} name={artist.name} handleClick={handleArtisteSelect}/>
                                    ))} */}
                                    
                                </ul> 
                                : null
                            }
                            
                        </div>
                        {/* <div className="dropdown">
                            <div ref={ref2} id="dropdownMusicSearch" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            </div>
                            <div className="col-md-8 px-0 dropdown-menu" aria-labelledby="dropdownMusicSearch">
                               <ul>
                                   {artistes && artistes.map( (artist, index) => (
                                       <ArtisteListItem key={index} name={artist.name}/>
                                   ))}
                                
                                </ul> 
                            </div>
                        </div> */}
                        <div className="dropdown">
                            <div ref={ref} id="dropdownFilter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            </div>
                            <div className="col-md-8 px-0 dropdown-menu" aria-labelledby="dropdownFilter">
                                <form className="filter-main">
                                    <div className="filter-head ">
                                        <div>
                                            <p className="text--black text--small">Filter By</p>
                                        </div>
                                        <div className={`box ${hasSelectedSubStation ? 'box--secondary ': 'box--grey' }`} onClick={ hasSelectedSubStation ? handleFilter : () => {}}>Apply Filter</div>
                                    </div>
                                    <div className="filter-legend">
                                        {/* Authentication Source */}
                                        Choose source
                                    </div>
                                    
                                    <div className="filter-option">

                                        <div className="d-flex flex-row align-items-center">
                                            <input type="radio" name="source" value="pandora" className="form-option mr-3" onChange={handleRadioChange}/>
                                            <p className="text--small text--grey">Pandora</p>
                                        </div>
                                        <div className="d-flex flex-row align-items-center my-2">
                                            <input type="radio" name="source" value="abuja" className="mr-3" onChange={handleRadioChange}/>
                                            <p className="text--small text--grey">Abuja</p>
                                        </div>
                                        <div className="d-flex flex-row align-items-center my-2">
                                            <input type="radio" name="source" value="lagos" className="mr-3" onChange={handleRadioChange}/>
                                            <p className="text--small text--grey">Lagos</p>
                                        </div>
                                        <div className="d-flex flex-row align-items-center my-2">
                                            <input type="radio" name="source" value="dstv" className="mr-3" onChange={handleRadioChange}/>
                                            <p className="text--small text--grey">Dstv</p>
                                        </div>
                                        <div className="d-flex flex-row align-items-center my-2">
                                            <input type="radio" name="source" value="ph" className="mr-3" onChange={handleRadioChange}/>
                                            <p className="text--small text--grey">Portharcourt</p>
                                        </div>
                                    
                                        
                                    </div>
                                    <div className="filter-legend">
                                        Choose station
                                    </div>
                                    <div className="filter-option alternate">
                                        
                                        {
                                            isLoadingStation ? 
                                            (<h1 className="text--small-bold text--black text-center my-4">Loading station ....</h1>) 
                                            : filteredSubstation && filteredSubstation.length  < 1 ? 
                                            (<h1 className="text--small-bold text--black text-center my-4">No Data</h1>)
                                            : (
                                                <Fragment>
                                                    <div className="mb-2">
                                                        <input className="nsForm-input" placeholder="Search for station" type="text" value={filterInput} onChange={handleSubstationFilter} />
                                                     </div>
                                                    {
                                                        filteredSubstation && filteredSubstation.map( (station, index) => (
                                                
                                                            <div key={index} className={`d-flex flex-row align-items-center ${index !== 0 ? 'my-3': null}`}>
                                                                <input type="radio" name="substation"  value={station.value} className="mr-3" onChange={handleSubstationChange}/>
                                                                <p className="text--small text--grey">{station.label}</p>
                                                            </div>
                                                        ))
                                                    }
                                                </Fragment>
                                                
                                                
                                            )
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className={`menu-panel ${showMobileMenu ? 'menu-panel__show': 'menu-panel__hide'}`}>
            <div className="row mx-0">
                <div className="mr-auto" onClick= {() => { toggleShowMobileMenu(false)}}>
                    <CloseIcon />
                </div>
            </div>
            <div className="w-100 mt-4">
                <div className="row">
                    <div className="col-6 mx-auto my-2">
                        <NavLink to={`${match.url}/profile`} className=""> <UserIcon width="16" height="16"/>Profile</NavLink>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mx-auto my-2">
                        <NavLink to={`${match.url}/profile/email`} className=""> <SettingsIcon/> Settings</NavLink>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mx-auto my-2">
                        <HelpIcon /> Help
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mx-auto my-2">
                        <div className="" onClick={logOut}> <LogOutIcon />Log out</div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        
    </Fragment>
}

export default CommonHeader2;